const EMPTY_PAYLOAD = {};
const JSON_START_CHARS = new Set(['{', '[', '"', '-', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 't', 'f', 'n']);

function should_parse_json(value = '') {
  return JSON_START_CHARS.has(String(value).trim().charAt(0));
}

export function parse_api_data(payload) {
  if (typeof payload !== 'string') return payload || {};
  return should_parse_json(payload) ? JSON.parse(payload) : EMPTY_PAYLOAD;
}

export function get_user_name(user = {}) {
  const full_name = [user.first_name, user.last_name].filter(Boolean).join(' ').trim();
  return full_name || user.email || 'Unnamed User';
}

export function map_user(profile = {}) {
  const user = profile.user || {};
  const role = user.role || {};
  return {
    id: profile.user_id || user.id,
    profile_id: profile.profile_id,
    first_name: user.first_name || '',
    last_name: user.last_name || '',
    name: get_user_name(user),
    email: user.email || '',
    role: role.role || role || 'User',
    role_id: role.id || user.role_id || null,
    phone_number: profile.phone_number || '',
    entity_type_id: profile.entity_type_id || '',
    entity_type_name: profile.entity_type_name || '',
    project_id: profile.project_id || null,
    is_active: profile.is_active ?? user.is_active,
  };
}

export const is_valid_email = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
export const is_valid_phone_number = (phone_number) => /^\d{10}$/.test(String(phone_number || '').trim());
export const has_valid_name = (name) => /^[A-Za-z][A-Za-z\s'-]{1,49}$/.test(String(name || '').trim());

export function is_coordinator_role(role) {
  return String(role || '').trim().toLowerCase().includes('coordinator');
}

export function create_form_defaults(default_role = '') {
  return {
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    role: default_role,
    entity_type_id: '',
  };
}

export function edit_form_defaults() {
  return {
    user_id: null,
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    role_id: '',
    entity_type_id: '',
    entity_type_name: '',
  };
}

export function assign_form_defaults() {
  return {
    user: null,
    project_ids: [],
    original_project_ids: [],
    project_search: '',
  };
}

export function get_entity_type_option_label(item = {}, index = 0) {
  return (
    item?.entity_type_name ||
    item?.name ||
    item?.domain_name ||
    item?.domain ||
    `Entity Type ${index + 1}`
  );
}

export function normalize_entity_type_option(item = {}, index = 0) {
  return {
    id: Number(item?.id || item?.entity_type_id || 0),
    name: get_entity_type_option_label(item, index),
    project_id: Number(item?.project_id || item?.project?.id || 0) || null,
    is_active: item?.is_active !== false,
  };
}

export function normalize_entity_type_option_name(name) {
  return String(name || '').trim().toLowerCase();
}

export function parse_error_message(error, fallback) {
  const response_data = parse_api_data(error?.response?.data);
  return response_data.message || response_data.data || error.message || fallback;
}

export function project_display_name(project) {
  return project?.project_name || project?.name || `Project ${project?.id || ''}`;
}
